import { render } from "./index.vue?vue&type=template&id=13877386&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13877386"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13877386', __exports__)) {
    console.log('reload')
    api.reload('13877386', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=13877386&ts=true", () => {
    console.log('re-render')
    api.rerender('13877386', render)
  })

}


export default __exports__